module.exports = __webpack_public_path__ + "img/ic_recommend.e6a5da3f.svg";